require('./bootstrap');

// Scroll to 
	window.goTo = function(target) {
		event.preventDefault()

		var headerOffset = 0;

		setTimeout(function() {
			var elementPosition = target.getBoundingClientRect().top;
			var offsetPosition = elementPosition - headerOffset;
			const startPos = window.pageYOffset;
			

			window.scrollTo({
				top: startPos + offsetPosition,
				behavior: "smooth"
			});
			
		}, 400);
	}

// 100VH
	const appHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);
	};

	window.addEventListener("resize", appHeight);
	appHeight();


//  Burger Menu
	function openNav() {
		let hamburger = {

			nav: document.querySelector('#nav'),
			navToggle: document.querySelector('.nav-toggle'),
			navLinks: document.querySelectorAll('.nav .nav-link'),
			body: document.querySelector('body'),

			initialize() {
				this.navToggle.addEventListener('click',
				() => { this.toggle(); });
			},

			initializeNavLinks() {
				this.navLinks.forEach(function(item) {
					item.addEventListener('click', function() {
						hamburger.toggle();
					})
				});
			},

			toggle() {
				this.navToggle.classList.toggle('expanded');
				this.nav.classList.toggle('expanded');
				this.body.classList.toggle('backdrop');
			},

		};
		hamburger.initialize();
		hamburger.initializeNavLinks();
		
		//return hamburger;
	};

// Scroll Effect Burger Menu
	function makeSticky() {
		let bannerProgram = document.querySelector('header');
		let stickySubNav = document.querySelector('nav');
		let HeightBannerProgram = bannerProgram.offsetHeight;
		
		window.addEventListener('scroll', function() { 
			if(window.scrollY >= HeightBannerProgram){
				stickySubNav.classList.add("scrolling");
			}else if(window.scrollY < HeightBannerProgram){
				stickySubNav.classList.remove("scrolling");
			}
		});
	}

AOS.init();

document.addEventListener('DOMContentLoaded', function() {	
	openNav();
	makeSticky();
}); 